























































































import { Component, Prop, Vue } from "vue-property-decorator";
import { IRoom, IRoomControl } from "@/@types/hotel/room";
import { IGuest } from "@/@types/admin/guest/user";
import { IVirtualRooma } from "@/@types/hotel/virtual_rooms";
import { ICruise } from "@/@types/cruiseOffers/cruiseList";

import RoomCard from "@/components/card/room/room-card.vue";
import RoomPlan from "./room-plan.vue";
import GuestRoomResettle from "./room_grapth/guest-room-resettle.vue";

@Component({
  components: {
    RoomCard,
    RoomPlan,
    GuestRoomResettle,
  },
})
export default class RoomRegistrationGests extends Vue {
  @Prop({ type: Array, default: () => [] }) guests!: Array<IGuest>;
  @Prop({ type: Array, default: () => [] }) roomLevels!: Array<IRoomControl>;
  @Prop({ type: Array, default: () => [] }) rooms!: Array<IRoom>;
  @Prop({ type: Array, default: () => [] }) roomTypes!: Array<IRoomControl>;
  @Prop({ type: Array, default: () => [] }) roomStatuses!: Array<IRoomControl>;
  @Prop({ type: Array, default: () => [] }) virtualRooms!: Array<IVirtualRooma>;
  @Prop({ type: String, default: "all" }) registrated!: string;
  @Prop({ type: Object, default: null }) sort!: { name: string; data: string };
  @Prop({ type: String, default: "" }) search!: string;
  @Prop({ type: Boolean, default: true }) show_plan_guests!: boolean;
  @Prop({ type: Boolean, default: true }) show_plan_children!: boolean;
  @Prop({ type: Boolean, default: true }) show_plan_pensioners!: boolean;
  @Prop({ type: Boolean, default: false }) show_plan_cell!: boolean;
  @Prop({ type: String, default: "" }) children!: string;
  @Prop({ type: Boolean, default: false }) pensioners!: boolean;
  @Prop({ type: String, default: "" }) birthday!: string;
  @Prop({ type: String, default: "" }) cruise_code!: string;
  @Prop({ type: String, default: "" }) gender!: string;
  @Prop({ type: String, default: "" }) doc_type!: string;
  @Prop({ type: String, default: "" }) citizenship!: string;
  @Prop({ type: String, default: "" }) room_type!: string;
  @Prop({ type: String, default: "" }) room_level!: string;
  @Prop({ type: Array, default: () => [] }) cruises!: Array<ICruise>;
  @Prop({ type: Array, default: () => [] }) citizenships!: Array<string>;

  get hasActiveSort(): boolean {
    return !!(
      this.children ||
      this.pensioners ||
      this.birthday ||
      this.cruise_code ||
      this.gender ||
      this.doc_type ||
      this.citizenship ||
      this.room_type ||
      this.room_level
    );
  }

  get childrenSortLabel(): string {
    if (!this.children) return "";
    const key = `Guests.List.sorts.children.${this.children}`;
    if (this.$te(key)) {
      return String(this.$t(key));
    }
    return this.children;
  }

  get cruiseCodeLabel(): string {
    if (!this.cruise_code || !this.cruises.length) return "";
    const cruise = this.cruises.find(
      (c: any) => String(c.id) === String(this.cruise_code)
    );
    return cruise ? this.$getLocale(cruise.name) : this.cruise_code;
  }

  get docTypeLabel(): string {
    if (!this.doc_type) return "";
    return this.doc_type;
  }

  get citizenshipLabel(): string {
    if (!this.citizenship) return "";
    return this.citizenship;
  }

  get roomTypeLabel(): string {
    if (!this.room_type || !this.roomTypes || !this.roomTypes.length) return "";
    const type = this.roomTypes.find((t: any) => t._id === this.room_type);
    return type ? this.$getLocale(type.name) : this.room_type;
  }

  get roomLevelLabel(): string {
    if (!this.room_level || !this.roomLevels || !this.roomLevels.length)
      return "";
    const level = this.roomLevels.find((l: any) => l._id === this.room_level);
    return level ? this.$getLocale(level.name) : this.room_level;
  }

  roomid = "";
  resettle: string[] = [];

  get vrooma(): IVirtualRooma | null {
    const vrooma = this.virtualRooms.find((vr) => vr.room == this.roomid);
    return vrooma ? vrooma : null;
  }

  openGuestForm(id: string): void {
    if (!id) return;
    this.$bvModal.show("guests");
    this.roomid = id;
  }
}
